var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "marker-pin-01"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 10.8333C11.3809 10.8333 12.5002 9.71404 12.5002 8.33332C12.5002 6.95261 11.3809 5.83332 10.0002 5.83332C8.61945 5.83332 7.50016 6.95261 7.50016 8.33332C7.50016 9.71404 8.61945 10.8333 10.0002 10.8333Z",
    stroke: "#1B262F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 18.3333C13.3335 15 16.6668 12.0152 16.6668 8.33332C16.6668 4.65142 13.6821 1.66666 10.0002 1.66666C6.31826 1.66666 3.3335 4.65142 3.3335 8.33332C3.3335 12.0152 6.66683 15 10.0002 18.3333Z",
    stroke: "#1B262F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.002ac0cf88abb0667f329505eb17ea71.svg";
export { ForwardRef as ReactComponent };